import _typeof from "@babel/runtime/helpers/typeof";
import { paramsToQueryString, sortBundlesParams } from "./url";
import DependencyManager from "../DependencyManager";
export var getBundleParams = function getBundleParams(reqProps, state) {
  var DependencyFunctions = DependencyManager.getDependency('functions');
  var paramsString = DependencyFunctions.getBundlesParams && DependencyFunctions.getBundlesParams(state, reqProps);
  var apiParams = reqProps.apiParams,
    bundleType = reqProps.bundleType;
  var params = {};
  if (paramsString) {
    params = Object.assign({}, JSON.parse(paramsString));
  }
  params = Object.assign(Object.assign(Object.assign({}, params), apiParams), {
    bundle: bundleType
  });
  return params;
};
export var getBundlesUrl = function getBundlesUrl(state, url) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sortedBundlesParams = sortBundlesParams(params);
  if (state.api && state.api.queryParam && state.api.queryParam.enableMultiLang) {
    sortedBundlesParams.lang = state.api.queryParam.lang;
  }
  var strParams = paramsToQueryString(sortedBundlesParams);
  return strParams ? "".concat(url, "?").concat(strParams) : url;
};
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
var isObject = function isObject(object) {
  return !isUndefined(object) && object != null && _typeof(object) === 'object';
};
export var isEmpty = function isEmpty(object) {
  return isObject(object) && (object.constructor === Object || object.constructor === Array) && Object.keys(object).length === 0 || !object;
};
export var locationsKeyMapper = function locationsKeyMapper(value, mapper) {
  if (isEmpty(mapper)) {
    return '';
  }
  return mapper[value] || value;
};
export var getLocationUrl = function getLocationUrl(location) {
  var queryStringParams = Object.assign({}, location === null || location === void 0 ? void 0 : location.query);
  var locationUrl = "".concat(location.pathname, "?").concat(paramsToQueryString(queryStringParams)).concat(location.hash);
  return locationUrl;
};